@if (policies()) {
  <div class="cl-main ">
    <router-outlet></router-outlet>
  </div>
}
@if (!policies()) {
  <div class="cl-main ">
    <app-logo-area [breadcrumbs]="[]"></app-logo-area>
    <main>
      <app-headline-section [title]="organization()?.name"></app-headline-section>
      <div class="col-12" style="height: 20vh"></div>
      <div style="width: 100%; display: flex;  align-items: center; justify-content: center;">
        @if (contextError(); as error) {
          <p class="alert cl-alert-danger" role="alert">{{ error }}</p>
        } @else {
          <div class="cl-spinner">Loading Policies & Licensed Services ...<i class="fas fa-spinner fa-spin"></i></div>
        }
      </div>
    </main>
  </div>
}
